import React, {Component} from 'react';
import Header from '../header/Header';
import Footer from '../footer/Footer';
import Datagrid from '../datagrid/Datagrid';
import axios from 'axios';
import ProductSearch from '../datagrid/Productsearch';

class DashboardPage extends Component {

    api = "https://cve-dashboard-service.herokuapp.com/api/";

    constructor (props) {
        super(props);
        this.state = {
            cves: [],
            productSearchInput: "",
            isLoading: true    
        }

        this.productSearchOnChangeHandler = this.productSearchOnChangeHandler.bind(this);
        this.productSearchOnClickHandler = this.productSearchOnClickHandler.bind(this);

    }

    /**
     * Make ajax call to the cve dashboard service here
     */
    componentDidMount () {
        this.fetchData();
    }

    /**
     * Check if user changed the severity and re-fetch the data if they did
     * @param {*} prevProps 
     */
    componentDidUpdate(prevProps) {
        if(prevProps.severity !== this.props.severity) {
            this.setState({
                isLoading: true
            })
            this.fetchData();
        }
    }

    /**
     * Default fetch method to search by severity or return top 10
     */
    fetchData() {
        let url = this.api + "cves";
        if (this.props.severity) {
            url = this.api + "cves?severity=" + this.props.severity;
        }

        axios.get(url).then ((response) => {
                this.setState({
                    cves: response.data,
                    isLoading: false
                })
            }
        );
    }

    /**
     * Update the grid when user searchs by product
     * @param {*} e 
     */
    productSearchOnClickHandler(e) {
        this.setState({
            isLoading: true
        })
        let url = this.api + "cves?product=" + this.state.productSearchInput;
        axios.get(url).then ((response) => {
                this.setState({
                    cves: response.data,
                    isLoading: false
                })
            }
        );
    }

    /**
     * Event handler to update state of the product search control
     * 
     * @param {*} e 
     */
    productSearchOnChangeHandler(e) {
        this.setState({
            productSearchInput: e.target.value
        })
    }

    /**
     * Display Header, ProductSearch, and Datagrid
     */
    render () {
        
        const loadingStyles = {
            "maxWidth": "1000px",
            "margin": "auto",
            "padding": "20px 20px"
        };

        return (

            <div>
                <Header />
                <ProductSearch 
                    productSearchInput={this.state.productSearchInput} 
                    productSearchOnChangeHandler={this.productSearchOnChangeHandler}
                    productSearchClickHandler={this.productSearchOnClickHandler}/>
                    
                {this.state.isLoading?
                    <p style={loadingStyles}>Loading, please wait...</p> :

                    <Datagrid title={this.props.title} cves={this.state.cves}/>
                } 

                <Footer />
            </div>
        )
    }
} 

DashboardPage.defaultProps = {
    title: "ALL"
}

export default DashboardPage;